import {
  DirectionsRenderer,
  GoogleMap,
  InfoWindow,
  Marker,
  OverlayView,
} from "@react-google-maps/api";
import React, { useCallback, useState } from "react";
import { FrankMondialPin } from "../../assets/images/FrankIcons";
import destinaionPinIcon from "../../assets/images/FrankIcons/destinationPinIcon.png";
import locImage from "../../assets/images/FrankIcons/myLoc.png";
import originPinIcon from "../../assets/images/FrankIcons/originPinIcon.png";
import MarkerPinIcon from "../../assets/images/FrankIcons/PinMarkerIcon.png";
import apiServices from "../../services/RequestHandler";
import { defaultLabelColors, greyStyle } from "../../utils/constants";
import { decodePolyline } from "../../utils/helper";
import Toast from "../Toast/Toast";

const containerStyle = {
  width: "100%",
  borderRadius: "32px",
  height: "100%",
  maxHeight: "100%",
};

const options = {
  disableDefaultUI: true, // Disables all default controls
  zoomControl: true, // Enables only the zoom control
  mapTypeControl: false, // Disables the map type control
  streetViewControl: false, // Disables street view control
  fullscreenControl: false, // Disables fullscreen control
  styles: greyStyle,
};

const optionsNormal = {
  disableDefaultUI: true, // Disables all default controls
  zoomControl: true, // Enables only the zoom control
  mapTypeControl: false, // Disables the map type control
  streetViewControl: false, // Disables street view control
  fullscreenControl: false, // Disables fullscreen control
};

interface MarkerData {
  id: number;
  // Add any other properties related to your job data
}

interface GoogleMapProps {
  handleGetLocation: (data: any) => void;
  markers_data?: Array<any>;
  relais_points?: Array<any>;
  normal_style?: boolean;

  origin?: any;
  handleGetJobInfo?: (data: MarkerData) => void;
  destination?: {};
  waypoints?: google.maps.DirectionsWaypoint[];
  handleGetRouteLog?: (data?: any) => void;

  for_mondial?: boolean;
  show_user_pointer?: boolean;
}

const isLatLngLiteral = (obj: any): obj is google.maps.LatLngLiteral => {
  return obj && typeof obj.lat === "number" && typeof obj.lng === "number";
};

function GoogleMaps({
  handleGetLocation,
  markers_data = [],
  relais_points = [],
  origin,
  destination,
  handleGetJobInfo,
  waypoints = [],
  handleGetRouteLog,
  normal_style = false,
  for_mondial = false,
  show_user_pointer = false,
}: GoogleMapProps) {
  // eslint-disable-next-line
  const [address, setAddress] = useState(null);

  const [userLocation, setUserLocation] =
    useState<google.maps.LatLngLiteral | null>(null);
  const [markerPosition, setMarkerPosition] = useState<{
    lat: number;
    lng: number;
  } | null>(null);
  const [directionsResponse, setDirectionsResponse] =
    useState<google.maps.DirectionsResult | null>(null);
    // eslint-disable-next-line
  const [error, setError] = useState<string | null>(null);

  const [state, setState] = React.useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      openJobDialog: false,
      openLoginDialog: false,
    }
  );

  const center = {
    lat: markerPosition?.lat || 48.85849254092111,
    lng: markerPosition?.lng || 2.3481133545091564,
  };
  // eslint-disable-next-line
  const [map, setMap] = React.useState(null);

 
// eslint-disable-next-line
  const calculateRoute = useCallback(() => {
    if (origin && destination) {
      const directionsService = new google.maps.DirectionsService();
      directionsService.route(
        {
          origin,
          destination,
          travelMode: google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK && result) {
            setDirectionsResponse(result);
            let decoded_routes = decodePolyline(
              result?.routes[0]?.overview_polyline
            );
            if (handleGetRouteLog) {
              handleGetRouteLog(decoded_routes);
            }
            setError(null);
          } else {
            setError(`Failed to get directions: ${status}`);
            Toast.Error("Aucun itinéraire possible disponible");
            setDirectionsResponse(null);
          }
        }
      );
    }
// eslint-disable-next-line
  }, [origin, destination]);

  React.useEffect(() => {
    if (origin && destination) {
      calculateRoute();
    }
    
  }, [origin, destination, calculateRoute]);

  

  
   
  const onMapPress = async (e: google.maps.MapMouseEvent) => {
    if (e.latLng) {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      try {
        let resp = await apiServices.getFromApi(
          `helper/get-address?lat=${lat}&lng=${lng}`,
          ""
        );
        setMarkerPosition({
          lat,
          lng,
        });
        setAddress(resp);

        if (handleGetLocation) {
          handleGetLocation(resp);

          const newLocation = {
            lat: resp?.result?.[0]?.latitude,
            lng: resp?.result?.[0]?.longitude,
          };

          setUserLocation(newLocation);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const CustomMarker = ({ item }: any) => {
    return (
      <div
        className="speech-bubble"
        style={{
          backgroundColor: "white",
          borderRadius: "16px",
          minWidth: "60px",
          maxWidth: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          padding: "5px ",
        }}
        onClick={() => {
          handleGetJobInfo && handleGetJobInfo(item);
        }}
      >
        <div style={{ flex: 1 }}>
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.5 7.27771L12 11.9999M12 11.9999L3.49997 7.27771M12 11.9999L12 21.5M21 16.0585V7.94141C21 7.59876 21 7.42744 20.9495 7.27464C20.9049 7.13947 20.8318 7.01539 20.7354 6.9107C20.6263 6.79236 20.4766 6.70916 20.177 6.54276L12.777 2.43164C12.4934 2.27409 12.3516 2.19531 12.2015 2.16442C12.0685 2.13709 11.9315 2.13709 11.7986 2.16442C11.6484 2.19531 11.5066 2.27409 11.223 2.43165L3.82297 6.54276C3.52345 6.70916 3.37369 6.79236 3.26463 6.9107C3.16816 7.01539 3.09515 7.13947 3.05048 7.27465C3 7.42745 3 7.59877 3 7.94141V16.0585C3 16.4012 3 16.5725 3.05048 16.7253C3.09515 16.8605 3.16816 16.9845 3.26463 17.0892C3.37369 17.2076 3.52345 17.2908 3.82297 17.4572L11.223 21.5683C11.5066 21.7258 11.6484 21.8046 11.7986 21.8355C11.9315 21.8628 12.0685 21.8628 12.2015 21.8355C12.3516 21.8046 12.4934 21.7258 12.777 21.5683L20.177 17.4572C20.4766 17.2908 20.6263 17.2076 20.7354 17.0892C20.8318 16.9845 20.9049 16.8605 20.9495 16.7253C21 16.5725 21 16.4012 21 16.0585Z"
              stroke="#ee6931"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16.5 9.5L7.5 4.5"
              stroke="#ee6931"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div
          style={{
            fontSize: "18px",
            fontWeight: "800",
            fontFamily: "Raleway-Italic",
            color: defaultLabelColors.main_blue,
          }}
        >
          {item?.ship_price}€
        </div>
      </div>
    );
  };

  const handleGetUserLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const newLocation = { lat: latitude, lng: longitude };
          setUserLocation(newLocation);
          handleGetLocation(newLocation);
        },
        (error) => {
          console.error("Error fetching location:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  return (
    <>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={isLatLngLiteral(origin) ? origin : userLocation || center}
        zoom={14}
        options={normal_style ? optionsNormal : options}
        onClick={(e) => onMapPress(e)}
      >
        {markers_data?.length < 1
          ? null
          : markers_data?.map((marker: any, index: number) => {
              let pickup;
              if (typeof marker?.pickup?.location === "string") {
                pickup = JSON?.parse(marker?.pickup?.location);
              } else {
                pickup = marker?.pickup?.location;
              }
              return (
                <>
                  <OverlayView
                    position={{
                      lat: pickup?.coordinates?.[0],
                      lng: pickup?.coordinates?.[1],
                    }}
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                  >
                    <div
                      style={{
                        position: "absolute",
                        transform: "translate(-50%, -100%)", // Centers the marker at the coordinates
                      }}
                    >
                      <CustomMarker item={marker} />
                    </div>
                  </OverlayView>
                </>
              );
            })}

        {relais_points &&
          relais_points?.map((marker: any) => {
            return (
              <OverlayView
                position={{
                  lat: marker?.latitude,
                  lng: marker?.longitude,
                }}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
              >
                <FrankMondialPin />
              </OverlayView>
            );
          })}

        {/* Render directions if the route is successfully calculated */}
        {directionsResponse && (
          <DirectionsRenderer
            directions={directionsResponse}
            options={{
              suppressMarkers: true,
              polylineOptions: {
                strokeColor: defaultLabelColors.main_blue,
                strokeWeight: 4,
              },
            }}
          />
        )}
        {isLatLngLiteral(origin) && (
          <Marker
            position={origin}
            icon={{
              url: originPinIcon,
              scaledSize: new window.google.maps.Size(50, 50),
            }}
          />
        )}
        {isLatLngLiteral(destination) && (
          <Marker
            position={destination}
            icon={{
              url: destinaionPinIcon,
              scaledSize: new window.google.maps.Size(50, 50),
            }}
          />
        )}
        {state.show_window && (
          <InfoWindow
            position={{
              lat: state.selected_marker?.pickup?.coordinates?.[0],
              lng: state.selected_marker?.pickup?.coordinates?.[1],
            }}
            onCloseClick={() =>
              setState({ show_window: false, selected_marker: null })
            }
          >
            <div
              style={{
                height: 100,
                width: 100,
                borderRadius: 16,
                background: "cyan",
              }}
            >
              <h1> </h1>
            </div>
          </InfoWindow>
        )}
        {for_mondial && (
          <Marker
            position={{
              lat: Number(origin?.lat ?? center.lat),
              lng: Number(origin?.lng ?? center.lng),
            }}
            icon={{
              url: MarkerPinIcon,
              scaledSize: new window.google.maps.Size(37, 42),
            }}
          />
        )}

        {show_user_pointer
          ? null
          : userLocation && (
              <Marker
                position={userLocation}
                icon={{
                  url: MarkerPinIcon,
                  scaledSize: new window.google.maps.Size(40, 42),
                }}
              />
            )}

        <button
          onClick={handleGetUserLocation}
          style={{
            position: "absolute",
            bottom: "120px",
            right: "10px",
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
          }}
        >
          <img
            src={locImage}
            alt="My Location"
            style={{ width: "20px", height: "20px" }}
          />
        </button>
      </GoogleMap>
    </>
  );
}

export default GoogleMaps;
